export default "__VITE_ASSET__c1b00061__"